export class Utils {
    static concatUrl(url, endpoint) {
        if (url.slice(-1) !== "/")
            url += "/";
        return url + endpoint;
    }
}
Utils.setVisibility = (control, isVisible) => {
    control.style.display = isVisible ? "inline" : "none";
};
